var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('o-component-demo',{attrs:{"title":"Label"}},[_c('o-label',[_vm._v(" First name ")]),_c('o-label',[_vm._v(" Middle name ")]),_c('o-label',[_vm._v(" Last name ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }